module.exports = __webpack_public_path__ + "assets/media/default-avatar.10207647.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/MeetingTypesPreview/default-avatar.png
// module id = 2460
// module chunks = 0